import authSaga from "./auth/sagas";
import signUpSaga from "./formSignUp/sagas";
import forgotPasswordSaga from "./formForgotPassword/sagas";

export default [authSaga(), signUpSaga(), forgotPasswordSaga()];
